import Breadcrumb from '../components/Breadcrumb';
import TitlePage from '../components/TitlePage';

const Services = () => {
    return (
        <>
            <Breadcrumb history={[{ title: 'Home', to: '/' }]} current='Servizi' />

            <section id='services' className='services'>
                <TitlePage title='Servizi' />
                <div className='container'>
                    <div className='row gy-4'>
                        <div className='col-12' data-aos='fade-up' data-aos-delay='100'>
                            <div className='row service-item position-relative'>
                                <div className='col-md-6'>
                                    <h4>STYLING & BACKSTAGE COORDINATION</h4>
                                    <p>Offriamo servizi personalizzati per organizzazioni di eventi di moda, tra cui:</p>
                                    <ul className='mt-2'>
                                        <li>
                                            <i className='bi bi-check2-circle'></i>
                                            <span>Stylist team (vestiaristi, aiuto designer, fitting, casting help, styling);</span>
                                        </li>
                                        <li>
                                            <i className='bi bi-check2-circle'></i>
                                            <span>Follow-up dei fitting e del coordinamento backstage.</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className='col-md-6 mt-3 mt-md-0 text-center'>
                                    <img src={'img/services/styling.webp'} className='img-fluid img-cover' alt='' />
                                </div>
                            </div>
                        </div>

                        <div className='col-12' data-aos='fade-up' data-aos-delay='100'>
                            <div className='row service-item position-relative'>
                                <div className='col-md-6'>
                                    <h4>BRAND IMAGE CONSULTING (consulenza esterna)</h4>
                                    <ul>
                                        <li>
                                            <i className='bi bi-check2-circle'></i>
                                            <span>
                                                Offriamo servizi di consulenza su misura per i brand, coprendo tutti gli aspetti
                                                dall'identità visiva e le sue diverse declinazioni, alla coerenza tra questi elementi.
                                            </span>
                                        </li>
                                        <li>
                                            <i className='bi bi-check2-circle'></i>
                                            <span>
                                                Ci occupiamo della comunicazione del brand in relazione al concept, al target e al tono di
                                                voce, oltre a sviluppare strategie efficaci per i social media.
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                                <div className='col-md-6 mt-3 mt-md-0 text-center'>
                                    <img src={'img/services/brand.webp'} className='img-fluid img-cover' alt='' />
                                </div>
                            </div>
                        </div>

                        <div className='col-12' data-aos='fade-up' data-aos-delay='100'>
                            <div className='row service-item position-relative'>
                                <div className='col-md-6'>
                                    <h4>MARKETING CONSULTING (consulenza esterna)</h4>
                                    <ul>
                                        <li>
                                            <i className='bi bi-check2-circle'></i>
                                            <span>
                                                Gestione dell'area marketing online nello specifico del mondo media (pianificazione,
                                                gestione, analisi e promozione contenuti)
                                            </span>
                                        </li>
                                        <li>
                                            <i className='bi bi-check2-circle'></i>
                                            <span>Creazione campagne pubblicitarie con analisi degli insights</span>
                                        </li>
                                        <li>
                                            <i className='bi bi-check2-circle'></i> <span>Creazione e-commerce via shopify</span>
                                        </li>
                                        <li>
                                            <i className='bi bi-check2-circle'></i> <span>Gestione eventi, programmazione e tesoreria</span>
                                        </li>
                                        <li>
                                            <i className='bi bi-check2-circle'></i> <span>Analisi di mercato</span>
                                        </li>
                                        <li>
                                            <i className='bi bi-check2-circle'></i> <span>Sem (search engine marketing)</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className='col-md-6 mt-3 mt-md-0 text-center'>
                                    <img src={'img/services/marketing.webp'} className='img-fluid img-cover' alt='' />
                                </div>
                            </div>
                        </div>

                        <div className='col-12' data-aos='fade-up' data-aos-delay='100'>
                            <div className='row service-item position-relative'>
                                <div className='col-md-6'>
                                    <h4>SHOOTING COMMERCIALI</h4>
                                    <ul>
                                        <li>
                                            <i className='bi bi-check2-circle'></i> <span>Ideazione concept e moodboard</span>
                                        </li>
                                        <li>
                                            <i className='bi bi-check2-circle'></i> <span>Fitting e servizio styling</span>
                                        </li>
                                        <li>
                                            <i className='bi bi-check2-circle'></i> <span>Gestione e selezione casting e team</span>
                                        </li>
                                        <li>
                                            <i className='bi bi-check2-circle'></i> <span>Location scouting</span>
                                        </li>
                                        <li>
                                            <i className='bi bi-check2-circle'></i>
                                            <span>
                                                Creazione contenuti fotografici e audio-visivi, Post editing e creazione video backstage
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                                <div className='col-md-6 mt-3 mt-md-0 text-center'>
                                    <img src={'img/services/shooting.webp'} className='img-fluid img-cover' alt='' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
export default Services;
